module.exports = __webpack_public_path__ + "media/images/icon-meet-mobile-white-bfc3dd2cd4d5c7acfeefee313af6494f.svg";